export type PublicEnvironment = {
  VITE_APP_URL?: string;
  VITE_BOOKING_API_URL?: string;
  VITE_AVAILABILITY_API_URL?: string;
  VITE_BOOKING_ADMIN_API_URL?: string;
  VITE_BOOKING_ADMIN_ACCESS_API_URL?: string;
  VITE_SUPABASE_URL?: string;
  VITE_SUPABASE_PUBLISHABLE_KEY?: string;
};

export type PublicConfig = {
  appUrl: string;
  bookingApiUrl: string;
  availabilityApiUrl: string;
  bookingAdminApiUrl: string;
  bookingAdminAccessApiUrl: string;
  supabaseUrl?: string;
  supabasePublishableKey?: string;
};

const DEFAULT_APP_URL = "https://book.raykschoerling.com";
// The browser uses server-side boundaries; privileged credentials never enter the static app.
const DEFAULT_BOOKING_API_URL = "https://cnejticdknokawqlslsj.supabase.co/functions/v1/booking-api";
const DEFAULT_AVAILABILITY_API_URL =
  "https://cnejticdknokawqlslsj.supabase.co/functions/v1/concierge-availability";
const DEFAULT_BOOKING_ADMIN_API_URL =
  "https://cnejticdknokawqlslsj.supabase.co/functions/v1/booking-admin";
const DEFAULT_BOOKING_ADMIN_ACCESS_API_URL =
  "https://cnejticdknokawqlslsj.supabase.co/functions/v1/booking-admin-access";

export function readPublicConfig(env: PublicEnvironment): PublicConfig {
  return {
    appUrl: env.VITE_APP_URL?.trim() || DEFAULT_APP_URL,
    bookingApiUrl: env.VITE_BOOKING_API_URL?.trim() || DEFAULT_BOOKING_API_URL,
    availabilityApiUrl: env.VITE_AVAILABILITY_API_URL?.trim() || DEFAULT_AVAILABILITY_API_URL,
    bookingAdminApiUrl: env.VITE_BOOKING_ADMIN_API_URL?.trim() || DEFAULT_BOOKING_ADMIN_API_URL,
    bookingAdminAccessApiUrl:
      env.VITE_BOOKING_ADMIN_ACCESS_API_URL?.trim() || DEFAULT_BOOKING_ADMIN_ACCESS_API_URL,
    supabaseUrl: emptyToUndefined(env.VITE_SUPABASE_URL),
    supabasePublishableKey: emptyToUndefined(env.VITE_SUPABASE_PUBLISHABLE_KEY),
  };
}

export function isSupabaseConfigured(config: PublicConfig): boolean {
  return Boolean(config.supabaseUrl && config.supabasePublishableKey);
}

function emptyToUndefined(value: string | undefined): string | undefined {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
}
